var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.92C1 13.0205 1.83443 15.035 3.31971 16.5203C4.805 18.0056 6.81949 18.84 8.92 18.84C11.0205 18.84 13.035 18.0056 14.5203 16.5203C16.0056 15.035 16.84 13.0205 16.84 10.92H8.92V3C7.87989 2.99987 6.84995 3.20464 5.88899 3.60261C4.92803 4.00058 4.05489 4.58396 3.31942 5.31942C2.58396 6.05489 2.00058 6.92803 1.60261 7.88899C1.20464 8.84995 0.999869 9.87989 1 10.92Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.79 8.52001H10.87V0.600006C11.9101 0.599875 12.94 0.804642 13.901 1.20261C14.862 1.60058 15.7351 2.18396 16.4706 2.91943C17.206 3.65489 17.7894 4.52804 18.1874 5.489C18.5854 6.44996 18.7901 7.4799 18.79 8.52001Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingIcon);
export default __webpack_public_path__ + "static/media/tradingIcon.38a3c5383c7c868d096a74f99559ce6b.svg";
export { ForwardRef as ReactComponent };